import {Injectable} from '@angular/core';
import {CanActivate, Router} from '@angular/router';
import {AuthenticationService} from './authentication.service';
import {ROUTES} from '../../app.routes';

/**
 * Guards routes meant only for e-commerce merchants (e.g. the ecommerce landing page). Non
 * e-commerce users are redirected to the home router, which sends them to their own dashboard.
 * The precise landing-vs-dashboard decision for an e-commerce merchant is made by the landing
 * page component based on their KYC status and role.
 */
@Injectable()
export class EcommerceGuardService implements CanActivate
{
    constructor(private router: Router, protected authenticationService: AuthenticationService)
    {
    }

    canActivate(): boolean
    {
        if (this.authenticationService.getUserLogin()?.eCommerceMerchant)
        {
            return true;
        }

        this.router.navigate([ROUTES.SECURE.HOME.VIEW.path]).then();
        return false;
    }
}
